<template>
	<div>
		
		<layout>

			<template v-slot:title> 
				BLOG
			</template>

			<template v-slot:subtitle> 
				BLOG
			</template>


			<template v-slot:content>
					
				<v-container>

					<v-card light v-if="posts != null">

						<div class="text-right">
							<v-btn dark to="/cms/crear-post/">Crear</v-btn>
						</div>


				    <v-card-title>
				      <v-text-field
				        v-model="search"
				        append-icon="mdi-magnify"
				        label="Buscar"
				        single-line
				        hide-details
				      ></v-text-field>
				    </v-card-title>
				    
				    <v-data-table
				      :headers="headers"
				      :items="posts"
				      :search="search"
				    >

					    <template v-slot:item.created_at="{ item }">
					      {{datetimeFormat(item.created_at)}}
					    </template>
				    	
				    	<template v-slot:item.options="{ item }">
				    	  <v-icon
				    	    @click="()=> { $router.push('/cms/editar-post/'+item.id) }"
				    	  >
				    	    mdi-pencil
				    	  </v-icon>

				    	  <v-icon
				    	    @click="deletePost(item)"
				    	  >
				    	    mdi-delete
				    	  </v-icon>
				    	</template>

				    </v-data-table>
				  
				  </v-card>

				</v-container>

		  </template>

		</layout>

	</div>
</template>


<script>
	
	import Layout from './../../layout/Layout'
	import BlogService from '@/shared/services/BlogService'


	export default
	{

		data() {
			return {
				search: '',
        headers: [
          { text: 'Titulo', align: 'start', filterable: true, value: 'title' },
          { text: 'Fecha', value: 'created_at', sortable: false },
          { text: 'Opciones', value: 'options', sortable: false },
        ],
        posts: null,
			}
		},

		components: {
			Layout
		},

		created() {
			this.getPosts()
		},

		methods: {

			async getPosts()
			{
				const resp = await BlogService.get()
				this.posts = resp.data
			},


			async deletePost(post)
			{
				SwalQuestion('', '¿Estas seguro(a) que deseas eliminar?', async resp =>
    		{
    			if(resp.isConfirmed)
    			{
    				const resp = await BlogService.delete(post.id)

    				if(resp.data == 'OK')
    				{
    					SwalMixin('Post eliminado', 'success')
    					this.getPosts()
    				}
    				else
    					SwalMixin('Ha ocurrido un error, por favor intenta de nuevo', 'error')
    			}
    		})
			}

		}

	}

</script>